import { httpClient } from "../http/httpClient"
import { SendProposalRequest, SendProposalResponse } from "../panService/sendProposal"

export async function sendProposalPan(
  id: string,
  payload: SendProposalRequest,
): Promise<SendProposalResponse> {
  const { data } = await httpClient
    .put<SendProposalResponse>(`/self-hire/transaction/${id}/send`, payload)
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
